import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import {BasicSelect,MultiSelect} from 'vue-search-select';
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import MasterService from './../../../services/masterdata.service';

export default {
  name: 'Slab',
  props: ['selectedEditRowData'],
  components: {
    VueElementLoading,
    Paginate,
    BasicSelect,
    vueMultiSelect
  },
  data: function() {
    return {
      slabDescription: '',
      slabName: '',
      slabType:'',
      WeightType:1,
      higherLevel:'',
      higherValue:'',
      lowerLimit:'',
      lowerlimitvalue:'',
      higherlimitvalue:'',
      SlabTypeObj:{
        '1':'Weight',
        '2':'InvoiceAmount',
        '3':'Distance'
      },
      SlabSubTypeObj:{
        '1':'Billable',
        '2':'Physical',
        '3':'Volumetric'
      },
      SymbolObj:{
        lt:'<',
        gt:'>',
        lte:'=<',
        gte:'>='
      },
      ShowWeightType:true,
      slabsData :[],
      slabbreakdetails: {
        LowerLimit: [],
        LowerLimitValue: [],
        HigherLimit: [],
        HigherLimitValue: []
      },
      isLoading: false,
      form:{
        lowerlimit:[],
        lowerlimitvalue:[],
        higherlimit:[],
        higherlimitvalue:[]
      }
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.setSaveFormDetails();
    //console.log(this.selectedEditRowData);
  },
  methods: {
    setSaveFormDetails(){
      if(this.selectedEditRowData.id){
        this.updateID = this.selectedEditRowData.id;
        this.getSlabDetails(this.updateID);
      } else {
        let slabsDataArr = [];
        this.updateID = null;
        this.slabDescription = "";
        this.slabName = "";
        this.slabType = "";
        slabsDataArr.push({
            selectedLowerLimit: '',
            selectedHigherLimit: '',
            lowerlimitvalue: '',
            higherlimitvalue: '',
          });
        this.slabsData = slabsDataArr;
        this.form.lowerlimit[0]='gte';
        this.form.higherlimit[0]='';
        this.ShowWeightType = false;
      }
    },
    setname(id, name){
      return name+id;
    },
    showCreateSlab() {
      this.$emit("goBackToParent")
    },
    ShowSlabTypeInput(){
      if (this.slabType == '1') {
        this.ShowWeightType = true
        this.checked = true
      } else {
        this.ShowWeightType = false
      }
    },
    addNewRow(index) {
      if (this.form.higherlimit[index] == 'lt' && this.form.higherlimitvalue[index] != '') {
        this.slabsData.push({
            selectedLowerLimit:'',
            selectedHigherLimit:'',
            lowerlimitvalue:'',
            higherlimitvalue:''
          });
        this.form.lowerlimit[index+1]='gte';
        this.form.higherlimit[index+1]='';
        this.form.lowerlimitvalue[index+1]= this.form.higherlimitvalue[index];
        this.form.higherlimitvalue[index+1]='';
      }else if(this.form.higherlimit[index] == 'lte' && this.form.higherlimitvalue[index] != ''){
        this.slabsData.push({
            selectedLowerLimit:'',
            selectedHigherLimit:'',
            lowerlimitvalue:'',
            higherlimitvalue:''
          });
        this.form.lowerlimit[index+1]='gt';
        this.form.higherlimit[index+1]='';
        this.form.lowerlimitvalue[index+1]= this.form.higherlimitvalue[index];
        this.form.higherlimitvalue[index+1]='';
      }else{
        if (this.form.higherlimitvalue[index] == '') {
          $( "#higherValue"+index ).addClass( 'error' );
        }
        if (this.form.higherlimit[index] == '') {
          $( "#higherLimit"+index ).addClass( 'error' );
        }
      }
    },
    setLowerLimit(data, index){
      this.slabsData[index].selectedLowerLimit = data.value;
    },
    setHigherimit(data, index){
      this.slabsData[index].selectedHigherLimit = data.value;
    },
    deleteRow(index) {
      this.$confirm("Remove selected slab breakup.",'','question').then(()=>{
        this.form.lowerlimit.splice(index, 1);
        this.form.higherlimit.splice(index, 1);
        this.form.lowerlimitvalue.splice(index, 1);
        this.form.higherlimitvalue.splice(index, 1);
        this.slabsData.splice(index, 1);
        if(this.form.lowerlimit[index] && this.form.lowerlimitvalue[index]){
          this.form.lowerlimitvalue[index] = this.form.higherlimitvalue[index - 1]
          if (this.form.higherlimit[index - 1] == 'lt') {
            this.form.lowerlimit[index] = 'gte'
          }else if(this.form.higherlimit[index - 1] == 'lte'){
            this.form.lowerlimit[index] = 'gt'
          }
        }
      });

    },
    async getSlabDetails(slabid){
      try {
        let InputPayload = {
          slabid: slabid
        }
        this.isLoading = true;
        let response = await MasterService.getSlabDetails(InputPayload);
        let slabDetails = response.data.data;

        let slabsDataArr = [];
        this.slabName = slabDetails.slabname;
        this.slabDescription = slabDetails.slabdescription;
        this.slabType = slabDetails.slabtype;
        if(this.slabType==1){
          this.WeightType = slabDetails.slabsubtype;
          this.ShowWeightType = true;
        }else{
          this.WeightType = '';
          this.ShowWeightType = false;
        }
        let slabdata = slabDetails.slabbreakupdetails;

        slabdata.forEach((item, index)=>{
          this.form.lowerlimit[index]=item.lowerlimit;
          this.form.higherlimit[index]=item.higherlimit;
          this.form.lowerlimitvalue[index]=item.lowerlimitvalue;
          this.form.higherlimitvalue[index]=item.higherlimitvalue;
        });

        slabdata.forEach(function (item) {
            slabsDataArr.push({
                selectedLowerLimit: item.lowerlimit,
                selectedHigherLimit: item.higherlimit,
                lowerlimitvalue: item.lowerlimitvalue,
                higherlimitvalue: item.higherlimitvalue,
              });
        });
        this.slabsData = slabsDataArr;
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    async saveSlab(){
      try {
        var inputPayload = {};
        if(this.updateID){
          inputPayload.slabid = this.updateID;
        }
        inputPayload.slabname = this.slabName.trim();
        inputPayload.slabdescription = this.slabDescription.trim();
        inputPayload.slabtype = this.slabType;
        if(this.slabType==1){
          inputPayload.slabsubtype = this.WeightType;
        }else{
          inputPayload.slabsubtype = null;
        }
        inputPayload.lastmodifiedby = this.userName;

        let SymbolObj = { "lt": "<", "lte": "<=", "gt": ">", "gte": ">=" };
        let slabbreakdetails = [];
        let isValid = 0;
        for(var i=0; i<this.form.lowerlimit.length; i++){
          if(i != 0){
            this.form.lowerlimitvalue[i] = this.form.higherlimitvalue[i-1]
          }
          if(parseInt(this.form.higherlimitvalue[i])<=parseInt(this.form.lowerlimitvalue[i])){
            isValid =1;
            $( "#higherValue"+i ).addClass( 'error' );
          }else if(parseInt(this.form.higherlimitvalue[i])==(parseInt(this.form.lowerlimitvalue[i])+1) && (SymbolObj[this.form.higherlimit[i]]!="<=")){
            isValid =1;
            $( "#higherLimit"+i ).addClass( 'error' );
          }
          else{
            $( "#higherValue"+i ).removeClass( 'error' );
            $( "#lowerValue"+i ).removeClass( 'error' );
          }
          slabbreakdetails.push({
              selectedLowerLimit: this.form.lowerlimit[i],
              lowerlimitvalue: this.form.lowerlimitvalue[i],
              selectedHigherLimit: this.form.higherlimit[i],
              higherlimitvalue: this.form.higherlimitvalue[i]
            });
        }
        inputPayload.slabbreakdetails = slabbreakdetails;
        if(isValid==0){
          this.isLoading = true;
          let result = await MasterService.saveSlab(inputPayload);
          this.isLoading = false;
          if (result.data.code == 200) {
            this.$alert(result.data.message, this.slabName, "success");
            this.$emit("goBackToParent");
          }else{
            this.$alert(result.data.message, this.slabName, "error");
          }
        }else{
          this.$alert("Invalid Slab breakup", this.slabName, "error");
        }
      } catch(err){
        this.isLoading = false;
        this.$alert(err, this.slabName, "error");
        console.log(err);
      }
    },
    resetSlabData(){
      this.slabsData = [];
      this.form = {
        lowerlimit:[],
        lowerlimitvalue:[],
        higherlimit:[],
        higherlimitvalue:[]
      };
      this.slabsData.push({
          selectedLowerLimit:'',
          selectedHigherLimit:'',
          lowerlimitvalue:'',
          higherlimitvalue:''
        });
      this.form.lowerlimit[0]='gte';
      this.form.higherlimit[0]='';
      this.form.lowerlimitvalue[0]= '';
      this.form.higherlimitvalue[0]='';
      if (this.slabType == '4') {
        console.log("form",this.form);
        this.form.lowerlimitvalue[0] = 1;
      }else{
        this.form.lowerlimitvalue[0] = 0;
      }
    },
    async removeError(index){
      $( "#higherValue"+index ).removeClass( 'error' );
      $( "#higherLimit"+index ).removeClass( 'error' );
      if(this.form.lowerlimit[index+1] && this.form.lowerlimitvalue[index+1]){
        this.form.lowerlimitvalue[index + 1] = this.form.higherlimitvalue[index]
        if (this.form.higherlimit[index] == 'lt') {
          this.form.lowerlimit[index+1] = 'gte'
        }else if(this.form.higherlimit[index] == 'lte'){
          this.form.lowerlimit[index+1] = 'gt'
        }
      }
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.saveSlab(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/Slabs/createSlab/createSlab.component.js